import { FormErrors, UseFormInput, UseFormReturnType } from "@mantine/form"
import { PathProxy } from "../../utils/forms-proxy"

export type FormProps<Values> = {
  handleValidationFailure?:
    | ((
        errors: FormErrors,
        values: Values,
        event: React.FormEvent<HTMLFormElement> | undefined
      ) => void)
    | undefined
  onSubmit: (
    values: Values,
    event: React.FormEvent<HTMLFormElement> | undefined,
    form: UseFormReturnType<Values>
  ) => void
  children:
    | React.ReactNode
    | React.ReactNode[]
    | ((
        form: UseFormReturnType<Values>,
        _: PathProxy<Values, Values>
      ) => React.ReactNode | React.ReactNode[])
} & UseFormInput<Values>

export const MantineFormContext = React.createContext<
  [
    UseFormReturnType<never, (values: never) => never>,
    React.RefObject<HTMLFormElement>,
  ]
>(null as never)
